import { useBoolean } from '@dreryk/react-common';

type PatientPregnancyModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
   closeModal: VoidFunction;
   modalOpened: boolean;
};
type PatientPregnancyModalOpenerProps = {
   children: (renderProps: PatientPregnancyModalOpenerChildrenRenderProps) => JSX.Element;
};

export const PatientPregnancyModalOpener = (props: PatientPregnancyModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return props.children({ modalOpened: modalOpened, openModal: openModal, closeModal: closeModal });
};
